let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5ff9A")).then(() => parcelRequire('cvbpu'));